module.exports = __webpack_public_path__ + "img/amex.d45203c0.svg";